import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createRegion } from "../services/create-region";
import { toast } from "@/hooks/use-toast";
import { RegionFormData } from "../schema/region-schema";

export function useCreateRegion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: RegionFormData) => createRegion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["regions"] });
      toast({ title: "Success", description: "Region created successfully" });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message || "Failed to create region",
        variant: "destructive",
      });
    },
  });
}
